// extracted by mini-css-extract-plugin
export var divider = "_27-0";
export var dividerText = "_27-2";
export var dividerVertical = "_27-1";